import { Controller } from "@hotwired/stimulus";

/**
 * GO4S Design System — fermeture d'un élément (alerte, bannière, toast).
 * À poser sur l'élément à retirer ; un enfant déclenche `ds-dismiss#close`.
 */
export default class extends Controller {
  close() {
    this.element.remove();
  }
}
